// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"SearchBox_searchBoxContainer__wUVob","symbolSearchBox":"SearchBox_symbolSearchBox__fCrGW","searchIcon":"SearchBox_searchIcon__Ry2rg"};